// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2PEfO","left":"InfoRow_left__1jTZ3"};